import { defineReactiveModel, Persistable, hasMany, belongsTo } from "vue-app-utils";
import Model from "@/models/model";

const Match = {
  extends: Model,
  mixins: [
    Persistable,
    hasMany("teams", {
      orderBy: ["createdAt"]
    }),
    belongsTo("tournament")
  ],
  data () {
    return {
      tableNumber: 0,
      active: true
    };
  },
  computed: {
    loaded () {
      if (this.teams.length < 2) return false;
      return this.teams.every(team =>
        team.playerIds.length > 0 &&
        team.players.length === team.playerIds.length &&
        team.players.every(player => !!player.name)
      );
    }
  }
};

export default defineReactiveModel(Match);